var modCheckoutAddress = function(){
    var scope = ".js-mod-checkout-address";
    var scopeCart = ".js-mod-cart-detail";

    function updateCartContents(){
        var $mod = $(scopeCart);
        gvf.endpoint(
            "web\\shopCartController::getCartContents",
            [],
            function(response){
                if(response.status=="ok"){
                    var $cart = $(response.html);
                    $mod.replaceWith($cart);
                    $mod = $cart;
                    ui.init($mod);
                }
            }
        );
    }

    function getCartDetail() {
        var $mod = $(scope);
        gvf.endpoint(
            "web\\shopProcessController::showViewCartDetail",
            null,
            function(response){
                if(response){
                    var $cartModal = $mod.find(scope+"__cart-detail");
                    var $html = $(response.html);
                    $html.removeClass("web-mod-cart-detail");
                    $cartModal.append($html);
                    ui.init($cartModal);

                }else{
                    utils.alertEndpointResponse(response);
                }
            }
        );
    }


    ui.ready(
        scope,
        function($mod){
            getCartDetail();
            var $form = $mod.find(scope+"__form");
            var $confirmButton = $mod.find(scope+"__confirm-step");
            var $showCartButton = $mod.find(scope+"__show-cart-detail");

            var $provinceSpain = $form.find("[name='deliver_data.geo_province_spain']");
            var $provinceAndorra = $form.find("[name='deliver_data.geo_province_andorra']");
            var $provincePortugal = $form.find("[name='deliver_data.geo_province_portugal']");
            var $provinceFrance = $form.find("[name='deliver_data.geo_province_france']");
            var $provinceItaly = $form.find("[name='deliver_data.geo_province_italy']");
            var $provinceBelgium = $form.find("[name='deliver_data.geo_province_belgium']");
            var $provinceLuxembourg = $form.find("[name='deliver_data.geo_province_luxembourg']");
            var $provinceGerman = $form.find("[name='deliver_data.geo_province_german']");
            var $provinceNetherlands = $form.find("[name='deliver_data.geo_province_netherlands']");
            var $country = $form.find("[name='deliver_data.geo_country_id']");

            function copyData(){
                $form.find("[data-name='invoice_data.id']").formFieldSetVal("");
                $form.find("[data-name^='deliver_data.']").each(function(){
                    var name = $(this).data("name").replace("deliver_data.", "invoice_data.");
                    $form.find("[data-name='"+name+"']").formFieldSetVal($(this).formFieldVal());
                    if($provinceSpain.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provinceSpain.find("option:selected").text());
                    }
                    if($provinceAndorra.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provinceAndorra.find("option:selected").text());
                    }
                    if($provincePortugal.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provincePortugal.find("option:selected").text());
                    }
                    if($provinceFrance.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provinceFrance.find("option:selected").text());
                    }
                    if($provinceItaly.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provinceItaly.find("option:selected").text());
                    }
                    if($provinceBelgium.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provinceBelgium.find("option:selected").text());
                    }
                    if($provinceLuxembourg.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provinceLuxembourg.find("option:selected").text());
                    }
                    if($provinceGerman.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provinceGerman.find("option:selected").text());
                    }
                    if($provinceNetherlands.val()>0){
                        $form.find("[data-name='invoice_data.province']").formFieldSetVal($provinceNetherlands.find("option:selected").text());
                    }
                })
            }

            $confirmButton.click(
                function(ev){
                    ev.preventDefault();
                    $form.submit();
                }
            );

            $mod.find(scope+"__cancel-edit-subscription").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\subscriptionsController::cancelSubscriptionEditing",
                        [],
                        function(response){
                            if(response.url){
                                window.location = response.url;
                            }else{
                                window.location.reload();
                            }
                        }
                    )
                }
            );

            $country.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [null, $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            )

            $provinceSpain.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provinceSpain.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );

            $provinceAndorra.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provinceAndorra.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );

            $provincePortugal.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provincePortugal.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );

            $provinceFrance.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provinceFrance.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );

            $provinceItaly.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provinceItaly.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );

            $provinceBelgium.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provinceBelgium.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );

            $provinceLuxembourg.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provinceLuxembourg.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );

            $provinceGerman.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provinceGerman.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );

            $provinceNetherlands.change(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    var adressId = $form.find("[data-name='deliver_data.id']").formFieldVal();
                    gvf.endpoint(
                        "web\\addressController::updateWebUserDelivryAddress",
                        [$provinceNetherlands.val(), $country.val(), adressId],
                        function(response){
                            if(response.status == 'ok'){
                                updateCartContents();
                                getCartDetail();
                            }
                        }
                    )
                }
            );


            var $copybtn = $mod.find(scope+"__copy-address");
            $copybtn.click(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    copyData();
                }
            );

            var $check = $mod.find(scope+"__copy-address-check");
            $check.on(
                "formField:changeVal",
                function(ev){
                    ev.preventDefault();
                    copyData();
                }
            );


            $form.find("[data-name='deliver_data.id'],[data-name='invoice_data.id']").on(
                "formField:changeVal",
                function(){
                    var id = $(this).formFieldVal();
                    var prefix = "deliver";

                    if($(this).data("name")=="invoice_data.id"){
                        prefix = "invoice";
                    }
                    if(id){
                        var addresses = $mod.data(prefix+"-addresses");
                        for(var i in addresses){
                            if(addresses[i].id==id){
                                for(var j in addresses[i]){
                                    if(j!="id"){
                                        $form.find("[data-name='"+prefix+"_data."+j+"']").formFieldSetVal(addresses[i][j]);
                                    }
                                }
                            }
                        }
                    }else{
                        $form.find("[data-name^='"+prefix+"_data.']").each(
                            function(){
                                if($(this).data("name")!=prefix+"_data.id"){
                                    $(this).formFieldSetVal("");
                                }
                            }
                        );
                    }
                }
            );

            var deliverDataId = $form.find("[data-name='deliver_data.id']")
            deliverDataId.on(
                "formField:changeVal",
                function(){
                    var acceptInvoice = $form.find("[data-name='accept_invoice']");

                    // deliverDataId.attr('option:selected').removeAttr('selected');
                    // deliverDataId.attr('option:selected');

                    if(!deliverDataId.formFieldVal()){
                        acceptInvoice.formFieldSetVal(0);
                    }else{
                        acceptInvoice.formFieldSetVal(1);
                    }
                }
            );

            $form.submit(
                function(ev){
                    ev.preventDefault();
                    if($form.find("[data-name='accept_invoice']").formFieldVal()==1){
                        copyData();
                    }
                    var isOk = $form.checkRestrictions();
                    if(isOk){
                        $confirmButton.prop("disable",true);
                        gvf.endpoint(
                            "web\\shopProcessController::confirmStep",
                            [$mod.data("step"),$form.getValues()],
                            function(response){
                                $confirmButton.prop("disable",false);
                                if(response.status=="ok"){
                                    window.location = response.url;
                                }else{
                                    utils.alertEndpointResponse(response);
                                }
                            }
                        );
                    }else{
                        gvf.endpoint(
                            "web\\addressController::getTextErrorLang",
                            [],
                            function(response){
                                utils.alertEndpointResponse(response);
                            }
                        );
                    }
                }
            );
        }
    );
    ui.readyBody(
        function($body){
            $body.on(
                "web:cartQuantityUpdate",
                function(ev,data){
                    gvf.delay(
                        1000,
                        function(){
                            getCartDetail();
                        }
                    );
                }
            );
        }
    );
}();
